import {Component} from '@angular/core';

@Component({
    selector: 'tfl-bo-blank-page',
    template: '<div id="blank-page-element"></div>'
})
export class BlankComponent {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/blank.component.ts